import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface SidebarUserProps {
  isCollapsed: boolean;
}

const SidebarUser: React.FC<SidebarUserProps> = ({ isCollapsed }) => {
  return (
    <div className="px-4 py-4 border-b border-[#616161]/20">
      <div className="flex items-center justify-center">
        {/* Logo with transition */}
        <AnimatePresence mode="wait">
          {isCollapsed ? (
            // Small logo when collapsed
            <motion.img
              key="small-logo"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              src="/assets/images/promoflowai-logo-sm.png"
              alt="PromoFlow AI"
              className="w-auto h-[45px]"
            />
          ) : (
            // Full logo when expanded
            <motion.img
              key="full-logo"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              src="/assets/images/promo-logo.png"
              alt="PromoFlow AI"
              className="w-auto h-[30px]"
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default SidebarUser;
